import React from 'react';
import Hero from '../../components/pages/VPSHosting/Hero/Hero';
import Dedicated from '../../components/pages/VPSHosting/Dedicated/Dedicated';
import WhyClients from '../../components/pages/VPSHosting/WhyClients/WhyClients';
import Packages from '../../components/pages/VPSHosting/Packages/Packages';
import Included from '../../components/pages/VPSHosting/Included/Included';
import RequestToResponse from '../../components/pages/VPSHosting/RequestToResponse/RequestToResponse';
import AccessControl from '../../components/pages/VPSHosting/AccessControl/AccessControl';
import FAQ from '../../components/pages/VPSHosting/FAQ/FAQ';
import Continuity from '../../components/pages/VPSHosting/Continuity/Continuity';

const VPSHosting = () => {
  return (
    <div>
      <Hero />
      <Dedicated />
      <WhyClients />
      <Packages />
      <Included />
      <RequestToResponse />
      <AccessControl />
      <FAQ />
      <Continuity />
    </div>
  );
};

export default VPSHosting;
